
	window.addEventListener("click",(event)=>{

			if(event.target.classList.contains("gallery_color") || event.target.closest(".gallery_color")){

				changeActiveColors(event.target);
			}

	})



	const changeActiveColors=(clickedColor)=>{
		console.log("clickedColor",clickedColor);
		const allGalleryColors = clickedColor.closest(".interactive_gallery_content").querySelectorAll(".gallery_color");
		const currentColorName = clickedColor.closest(".interactive_gallery_content").querySelector(".current_color_name");
		const allGallerySlides = clickedColor.closest(".interactive_gallery_content").querySelectorAll(".gallery_slide");

		allGalleryColors.forEach(color=>{
			if(color === clickedColor){
				const activeColorDOM  = color.querySelector(".activeColor");
				color.classList.add("active")
				activeColorDOM.style.border=`2px solid ${clickedColor.getAttribute("data-color")}`;
			currentColorName.textContent = `${clickedColor.getAttribute("data-color-name")}`;
			allGallerySlides.forEach(gs =>{
				if(gs.getAttribute("data-color-name") == clickedColor.getAttribute("data-color-name")){
					gs.classList.add("active_slide")
				}
				else{
					if(gs.classList.contains("active_slide"))
					gs.classList.remove("active_slide")
				}
			})

			}
			else{
				if(color.classList.contains("active")){
					color.classList.remove("active")
				}
			}
			
			
		})

	}
